<section class="w-full">
        @if(view.site) {
        <div
            class="w-full relative h-[400px] bg-cover bg-no-repeat bg-center flex flex-col justify-center items-center" [ngStyle]="{ 'background-image': 'url(' + view.imageHref + ')' }">
            <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
            <h1 class="z-10 custom_font text-6xl text-white text-shadow">{{view.title}}</h1>
            <!-- <p class="z-10 text-xl text-white font-semibold"><span class="text-emerald-500 font-semibold">Home</span> / Contact</p> -->
        </div>
    }
    <div class="px-0 md:px-15 lg:px-15 dark:bg-gray-900" id="contact">
        <div
            class="px-4 py-4 sm:py-8 md:py-8 lg:py-8 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 md:gap-y-8 lg:gap-x-8 lg:gap-y-16">
            <fuse-card class=" flex flex-col p-4 sm:p-8 sm:p-8 md:p-8 lg:p-8">
                <h1 class="text-6xl font-semibold custom_font text-accent-">Reach Us Anytime</h1>
                <form action="" method="post">
                    <div class="w-full">
                        <div class="flex flex-wrap -m-2">
                            <div class="p-2 w-1/2">
                                <div class="mt-1">
                                    <label for="name" class="leading-7 text-md font-semibold text-gray-600">Name<span
                                            class="text-red-500">*</span></label>
                                    <div class="relative">
                                        <input type="text" id="firstName" name="firstName" placeholder="Enter First Name" [(ngModel)]="view.message.firstName"
                                            class="w-full block h-10 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
                                        <span class="absolute inset-y-0 right-0 flex items-center justify-center mr-2">
                                            <mat-icon class="icon-size-5 text-gray-400"
                                                [svgIcon]="'mat_solid:person_outline'"></mat-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 w-1/2">
                                <div class="mt-1">
                                    <label for="name" class="leading-7 text-md font-semibold text-gray-600">Surname<span
                                            class="text-red-500">*</span></label>
                                    <div class="relative">
                                        <input type="text" id="lastName" name="lastName" placeholder="Enter Surname" [(ngModel)]="view.message.lastName"
                                            class="w-full block h-10 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
                                        <span class="absolute inset-y-0 right-0 flex items-center justify-center mr-2">
                                            <mat-icon class="icon-size-5 text-gray-400"
                                                [svgIcon]="'mat_solid:person_outline'"></mat-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 w-1/2">
                                <div class="relative">
                                    <label for="phone" class="leading-7 text-md font-semibold text-gray-600">Phone</label>
                                    <div class="relative">
                                        <input type="text" id="phone" name="phone" placeholder="Phone Number" [(ngModel)]="view.message.phoneNumber"
                                            class="w-full block h-10 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
                                        <span class="absolute inset-y-0 right-0 flex items-center justify-center mr-2">
                                            <mat-icon class="icon-size-5 text-gray-400"
                                                [svgIcon]="'feather:phone'"></mat-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 w-1/2">
                                <div class="relative">
                                    <label for="email" class="leading-7 text-md font-semibold text-gray-600">Email<span
                                            class="text-red-500">*</span></label>
                                    <div class="relative">
                                        <input type="text" id="email" name="email" placeholder="Your Email" [(ngModel)]="view.message.emailAddress"
                                            class="w-full block h-10 bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
                                        <span class="absolute inset-y-0 right-0 flex items-center justify-center mr-2">
                                            <mat-icon class="icon-size-5 text-gray-400"
                                                [svgIcon]="'feather:mail'"></mat-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="p-2 w-full">
                                <div class="relative">
                                    <label for="message"
                                        class="leading-7 text-md font-semibold text-gray-600">Message</label>
                                    <textarea id="message" name="message" placeholder="What's on you mind..." [(ngModel)]="view.message.comments"
                                        class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out">
                                    </textarea>
                                </div>
                            </div>
                            <div class="p-2">
                                <button [ngClass]="{ 'bg-accent-500 text-gray-500 cursor-not-allowed': !isFormValid(),
                                    'bg-accent-500 text-primary-100 cursor-pointer hover:text-primary-500 hover:bg-primary-100 transition ease-out duration-500': isFormValid()
                                    }"
                                    class="w-full rounded-b-xl uppercase font-semibold p-3 border-accent-500"
                                    type="submit" (click)="sendMessage()">
                                    {{isFormValid() ? 'Send Message Now' : 'Complete all fields'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

            </fuse-card>
            @if(view.site) {
                <fuse-card class="flex flex-col w-full  p-4 md:p-10 lg:p-10">
                    <div class="flex flex-col">
                        <h1 class="text-6xl font-semibold custom_font tracking-wide mb-2 dark:text-black">Contact Info</h1>
                        <div class="flex items-baseline">
                            <span class="w-10 border-b-2 border-primary-500"></span>
                            <span class="w-3 ml-1 border-b-2 border-primary-500"></span>
                        </div>
                    </div>
                    @if(view.site?.telephone) {
                    <div class="mt-5">
                        <h4 class="text-xl font-semibold custom_font tracking-wide mb-2 dark:text-black">Phone Number:</h4>
                    </div>
                    <div class="flex items-center mt-4">
                        <div class="flex items-center">
                            <div
                                class="flex items-center justify-center mr-5 w-12 h-12 bg-primary-500 border-none rounded-full">
                                <mat-icon class="icon-size-5 text-white" [svgIcon]="'mat_solid:phone'"></mat-icon>
                            </div>
                            <div class="flex flex-col">
                                <p class="dark:text-black">{{view.site?.telephone}}</p>
                            </div>
                        </div>
                    </div>
                    }
                    @if(view.site?.emailAddress) {
                        <div class="mt-5">
                            <h4 class="text-xl font-semibold custom_font tracking-wide mb-2 dark:text-black">Email Address:</h4>
                        </div>
                        <div class="flex items-center mt-4">
                            <div class="flex items-center">
                                <div
                                    class="flex items-center justify-center mr-5 w-12 h-12 bg-primary-500 border-none rounded-full">
                                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'mat_solid:email'"></mat-icon>
                                </div>
                                <div class="flex flex-col">
                                    <p class="dark:text-black">{{view.site?.emailAddress}}</p>
                                </div>
                            </div>
                        </div>
                    }
                    @if(view.site.address) {
                        <div class="mt-5">
                            <h4 class="text-xl font-semibold custom_font tracking-wide mb-2 dark:text-black">Location:</h4>
                        </div>
                        <div class="flex items-center mt-4">
                            <div class="flex items-center">
                                <div
                                    class="flex items-center justify-center mr-5 w-12 h-12 bg-primary-500 border-none rounded-full">
                                    <mat-icon class="icon-size-5 text-white" [svgIcon]="'mat_solid:location_on'"></mat-icon>
                                </div>
                                <div class="flex flex-col">
                                    <p class="dark:text-black">{{view.site.address}}</p>
                                </div>
                            </div>
                        </div>
                    }
                </fuse-card>
            }

        </div>
    </div>
    <div>
        <section>
            <div class="w-full h-128 rounded-lg bg-gray-200">
                <google-map height="100%" width="100%" [center]="{ lat:  view.defaultLat, lng: view.defaultLng }"
                    [zoom]="15">
                    <map-marker [position]="{  lat: view.defaultLat,  lng:  view.defaultLng  }">
                    </map-marker>
                </google-map>
            </div>
    
        </section>
    </div>
</section>